import { render } from "./under-construction.vue?vue&type=template&id=23136b84"
import script from "./under-construction.vue?vue&type=script&lang=js"
export * from "./under-construction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__